import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useResolutions } from 'store/resolutions'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Datepicker from 'components/shared/Datepicker'
import { RadioTileGroup } from 'components/shared/RadioTileGroup'
import SpaCalendarModal from 'components/global/CalendarModal/forks/SpaCalendarModal'
import { DateSelectorProps } from './DateSelector.types'
import {
    getDayOfWeek,
    getFormatedDate,
} from 'routes/Upsell/SpaCreator/helpers/dateSelector'

export const DateSelector = ({
    value,
    dates,
    onDateSelect,
}: DateSelectorProps) => {
    const { formatMessage, locale } = useIntl()
    const { isMobile } = useResolutions()

    const [isCalendarModalOpened, setIsCalendarModalOpened] = useState(false)

    const handleCalendarModalOpen = () => setIsCalendarModalOpened(true)
    const handleCalendarModalClose = () => setIsCalendarModalOpened(false)
    const handleChangeDate = (date: string) => onDateSelect(date)

    return (
        <Box isFullWidth gap={[8, 16]}>
            <Text variant="heading5" color="grayscale_900">
                <FormattedMessage
                    id="upsells.wellness.choose_date"
                    defaultMessage="Wybierz datę"
                />
            </Text>
            {dates?.length ? (
                <RadioTileGroup
                    value={value}
                    columns={isMobile ? 2 : 3}
                    onChange={onDateSelect}
                    data-testid="spa-date"
                >
                    {dates.map((date) => (
                        <RadioTileGroup.SimpleItem
                            key={date}
                            id={date}
                            value={date}
                            label={getFormatedDate(date)}
                            description={getDayOfWeek(date, locale)}
                        />
                    ))}
                </RadioTileGroup>
            ) : (
                <Box width={['100%', 264]}>
                    <Datepicker
                        id={'spaDate'}
                        value={value ? [value] : []}
                        openCalendar={handleCalendarModalOpen}
                        placeholder={formatMessage({
                            id: 'global.input.select_date_placeholder',
                            defaultMessage: 'Wybierz datę',
                        })}
                        testId={'spa-trigger-treatment-date'}
                    />
                </Box>
            )}

            <SpaCalendarModal
                date={value}
                onChange={handleChangeDate}
                onClose={handleCalendarModalClose}
                isOpened={isCalendarModalOpened}
            />
        </Box>
    )
}
